export const THREAD_TAG_TYPE = 'Thread' as const;
